import { Shot, ShotFeed, baseShotFeed, FEED_TYPES } from '../stores/reducers/shots';
import { isOneUpLayout, isTwoUpLayout } from './video-layout';

const editShotLayout = (
	shot: Shot,
	layout: string,
	itemCount: number,
): Shot | null => {
	const editedShot: Shot = JSON.parse(JSON.stringify(shot));
	// Need to split the two types of feeds so the audio feeds don't influence the layout
	const canvasFeeds = editedShot.shot_data.shotFeeds
		.filter((feed: ShotFeed) => !feed.audioOnly);
	const audioFeeds = editedShot.shot_data.shotFeeds
		.filter((feed: ShotFeed) => feed.audioOnly);
	
	const prevLayout = editedShot.shot_data.forcedLayout;
	editedShot.shot_data.forcedLayout = layout;
	if (isOneUpLayout(prevLayout) && isTwoUpLayout(layout) && canvasFeeds[0].feedType === FEED_TYPES.MEDIA) {
		// if a media item is in a 1UP layout, and the user changes to a 2UP layout,
		// put the media item in the TWO position.
		editedShot.shot_data.shotFeeds = [
			baseShotFeed,
			...canvasFeeds,
			...audioFeeds
		];
	} else if (itemCount > canvasFeeds.length) {
		// if the new layout supports a larger number of feeds than there are in the current shot
		// preserve the current order from the shot and fill the rest up with empty slots
		editedShot.shot_data.shotFeeds = [
			...canvasFeeds,
			...new Array(itemCount - canvasFeeds.length).fill(baseShotFeed),
			...audioFeeds,
		];
	} else if (itemCount < canvasFeeds.length) {
		// if the new layout does not support the number of feeds that are in the current shot
		// preserve as many feeds that will fit in the new layout
		editedShot.shot_data.shotFeeds = [
			...canvasFeeds.slice(0, itemCount),
			...audioFeeds,
		];
	}

	// update shotFeed positions
	editedShot.shot_data.shotFeeds.forEach((feed, index) => {
		feed.position = index;
	});

	return editedShot || null;
};

export default editShotLayout;
